<div class="breadcrumb-container" *ngIf="breadcrumbs && breadcrumbs.length > 0">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb mt-0 gradient title shadow">
      <li class="breadcrumb-item" *ngFor="let item of breadcrumbs; let last = last"
        [class.active]="item.isActive || last">
        <a *ngIf="!item.isActive && !last && item.url" (click)="navigateTo(item); $event.preventDefault()" [href]="item.url" class="breadcrumb-link">
          {{ item.label }} </a>
        <span *ngIf="item.isActive || last || !item.url" class="breadcrumb-text">
          {{ item.label }}
        </span>
        <i *ngIf="!last" class="breadcrumb-separator">&gt;</i>
      </li>
    </ol>
  </nav>
</div>